import axios from 'axios'
import configuration from '../configuration'
import defaultTranslation from '../translations/it_IT'
const { translations } = configuration

export const getTranslation = async (language = 'it_IT') => {
  const {data} = await axios.get(`${translations.hostname}/${language}.json`)
  if (!data) return defaultTranslation
  return data
}